export function StepProgressBar({
  fillId,
  isVisible,
}: {
  fillId: string;
  isVisible: boolean;
}) {
  if (!isVisible) return null;

  return (
    <div className="fixed top-[56px] left-0 right-0 z-40 h-1 bg-gray-200 xl:fixed xl:top-0 xl:left-0 xl:right-0 xl:z-50">
      <div
        id={fillId}
        className="bg-remedium-blue h-full"
        style={{
          width: "0%",
          transition: "width 80ms linear, background-color 300ms ease",
          willChange: "width",
        }}
      />
    </div>
  );
}
